import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";

import { FiPlusCircle } from "react-icons/fi";

import PopUp from "../../components/PopUp";
import { Chip, InfoBlock, RectBtn } from "../../components/General";
import { toSentenceCase } from "../../utils/General";

import { addAuthorization, deleteAuthorization } from "../../apis/Auth.Api";
import { FaTimesCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { selectRoom, selectUserData, selectBuilding } from "../../features/store";
import { useSnackbar } from "notistack";
const InspectAccountPopUp = ({
    selectedUser,
    selectedUserRooms,
    setSelectedUserRooms,
    openInspect,
    setOpenInspect,
    canDelete,
    setCanDelete,
}) => {
    const { enqueueSnackbar } = useSnackbar();
    const [roomMenu, setRoomMenu] = useState([]);
    const [buildingMenu, setBuildingMenu] = useState([]);
    const rooms = useSelector(selectRoom);
    const buildings = useSelector(selectBuilding);
    const [authRoomsToDelete, setAuthRoomsToDelete] = useState(null);
    const [openAddAuth, setOpenAddAuth] = useState(false);
    const [openAddAllAuth, setOpenAddAllAuth] = useState(false);
    const [authRoomsToAdd, setAuthRoomsToAdd] = useState([]);
    const [authRoomsToAddByBuilding, setAuthRoomsToAddByBuilding] = useState([]);
    const handleCheck = (roomToCheck) => {
        for (let element of authRoomsToAdd) {
            if (element.roomId === roomToCheck.roomId) return true;
        }
        return false;
    };
    const handleBuildingCheck = (buildingToCheck) => {
        for (let element of authRoomsToAddByBuilding) {
            if (element.buildingId === buildingToCheck.buildingId) return true;
        }
        return false;
    };
    const permissionConverter = {
        0: "Super Admin",
        1: "Admin",
        2: "Manager",
        3: "Viewer",
    };
    async function confirmDeleteAuth() {
        let payload = [];
        for (let roomId of Object.keys(authRoomsToDelete)) {
            const obj = {
                user_id: selectedUser.userId,
                room_id: roomId,
            };
            payload.push(obj);
        }

        let r = await deleteAuthorization({ payload: payload });
        if (!r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });
        setAuthRoomsToDelete(null);
    }
    function cancelAddAuth() {
        setOpenAddAuth(false);
        setOpenAddAllAuth(false);
        setAuthRoomsToAdd([]);
        setAuthRoomsToAddByBuilding([]);
    }
    async function confirmAddAuth() {
        let payload = [];
        let selectedUserRoomsCopy;
        let submitAuthRoomsToAdd = [];
        if (!selectedUserRooms) {
            selectedUserRoomsCopy = {};
        } else {
            selectedUserRoomsCopy = JSON.parse(JSON.stringify(selectedUserRooms));
        }

        if (authRoomsToAddByBuilding.length !== 0) {
            for (let buliding of authRoomsToAddByBuilding) {
                submitAuthRoomsToAdd = [...submitAuthRoomsToAdd, ...roomMenu[buliding.buildingId]];
            }
        } else {
            submitAuthRoomsToAdd = [...authRoomsToAdd];
        }
        for (let room of submitAuthRoomsToAdd) {
            const obj = {
                user_id: selectedUser.userId,
                room_id: room.roomId,
            };
            payload.push(obj);
            const parseRoom = {
                buildingId: room.buildingId,
                floor: room.floor,
                roomId: room.roomId,
                roomName: room.roomName,
                hidden: false,
            };

            selectedUserRoomsCopy[room.roomId] = parseRoom;
        }
        let res = await addAuthorization({ payload: payload });
        if (!res.data.indicator) {
            enqueueSnackbar(res.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(res.data.message, { variant: "success" });
        setSelectedUserRooms(selectedUserRoomsCopy);
        setAuthRoomsToAdd([]);
        setAuthRoomsToAddByBuilding([]);
        setOpenAddAuth(false);
        setOpenAddAllAuth(false);
    }
    return (
        <PopUp width={60} height={80} switchOn={openInspect}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Account Details</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenInspect(false);
                            setOpenAddAuth(false);
                            setOpenAddAllAuth(false);
                            setCanDelete(false);
                            setAuthRoomsToDelete(null);
                            setAuthRoomsToAdd([]);
                            setSelectedUserRooms({});
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="pop-up-row -wrap info-block-row">
                        {Object.keys(selectedUser)
                            .splice(1)
                            .map((key, i) => (
                                <InfoBlock
                                    key={"infoBlock" + i}
                                    title={toSentenceCase(key)}
                                    value={`${selectedUser[key].toString()} ${
                                        key === "permission" ? "- " + permissionConverter[selectedUser.permission] : ""
                                    }`}
                                />
                            ))}
                    </div>

                    {selectedUser.permission !== 0 && (
                        <div className="account-detail-interactive-block">
                            <InfoBlock
                                title={"Authorized Rooms"}
                                headerExtension={
                                    selectedUserRooms && (
                                        <div className="toggle">
                                            <p> Toggle to enable delete </p>
                                            <FormControlLabel
                                                control={<Switch color="warning" checked={canDelete} size="small" />}
                                                onChange={(e) => {
                                                    if (!e.target.checked) {
                                                        // unhide every room
                                                        let roomsCopy = JSON.parse(JSON.stringify(selectedUserRooms));
                                                        for (let key in authRoomsToDelete) {
                                                            roomsCopy[key].hidden = false;
                                                        }
                                                        setSelectedUserRooms(roomsCopy);
                                                        // remove rooms in authRoomsToDelete
                                                        setAuthRoomsToDelete(null);
                                                    }
                                                    setCanDelete(e.target.checked);
                                                }}
                                            />
                                        </div>
                                    )
                                }
                            >
                                <div className="chip-row">
                                    {selectedUserRooms &&
                                        Object.keys(selectedUserRooms).map((key, i) => {
                                            let item = selectedUserRooms[key];
                                            return (
                                                !item.hidden && (
                                                    <Chip
                                                        key={"chip" + i}
                                                        status={"None"}
                                                        text={item.roomName}
                                                        deletable={canDelete}
                                                        disableClicking={!canDelete}
                                                        onDelete={() => {
                                                            // hide room chip from selectedUserRooms
                                                            let roomsCopy = JSON.parse(
                                                                JSON.stringify(selectedUserRooms)
                                                            );
                                                            roomsCopy[key].hidden = true;

                                                            setSelectedUserRooms(roomsCopy);
                                                            // push room chip to authRoomsToDelete
                                                            let roomsToDeleteCopy;
                                                            if (authRoomsToDelete) {
                                                                roomsToDeleteCopy = JSON.parse(
                                                                    JSON.stringify(authRoomsToDelete)
                                                                );
                                                            } else {
                                                                roomsToDeleteCopy = {};
                                                            }

                                                            roomsToDeleteCopy[key] = item;

                                                            setAuthRoomsToDelete(roomsToDeleteCopy);
                                                        }}
                                                    />
                                                )
                                            );
                                        })}
                                    <Chip
                                        text={"Add a Room"}
                                        status={"Icon"}
                                        icon={<FiPlusCircle />}
                                        onClick={() => {
                                            setOpenAddAuth(true);

                                            let arr = [];

                                            for (let rid of Object.keys(rooms)) {
                                                if (
                                                    Object.keys(selectedUserRooms).length === 0 ||
                                                    !selectedUserRooms[rid]
                                                ) {
                                                    arr.push(rooms[rid]);
                                                }
                                            }
                                            setRoomMenu(arr);
                                        }}
                                    />
                                    <Chip
                                        text={"Add all Rooms by Building"}
                                        status={"Icon"}
                                        icon={<FiPlusCircle />}
                                        onClick={() => {
                                            setOpenAddAllAuth(true);

                                            let roomObj = {};
                                            let buildingArr = [];

                                            for (let bid of Object.keys(buildings)) {
                                                buildingArr.push(buildings[bid]);
                                                roomObj[buildings[bid].buildingId] = [];
                                            }

                                            for (let rid of Object.keys(rooms)) {
                                                if (
                                                    Object.keys(selectedUserRooms).length === 0 ||
                                                    !selectedUserRooms[rid]
                                                ) {
                                                    const bid = rooms[rid].buildingId;

                                                    if (!roomObj[bid]) {
                                                        roomObj[bid] = [];
                                                    }

                                                    roomObj[bid].push(rooms[rid]);
                                                }
                                            }

                                            setRoomMenu(roomObj);
                                            setBuildingMenu(buildingArr);
                                        }}
                                    />
                                </div>
                            </InfoBlock>

                            {openAddAuth && (
                                <div className="add-auth-menu-content">
                                    <p> Add Rooms </p>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel id="rooms-label">Rooms To Add</InputLabel>
                                        <Select
                                            labelId="rooms-label"
                                            id="demo-multiple-checkbox"
                                            multiple
                                            value={authRoomsToAdd}
                                            onChange={(event) => {
                                                setAuthRoomsToAdd(event.target.value);
                                            }}
                                            input={<OutlinedInput label="Rooms To Add" />}
                                            renderValue={(selected) => {
                                                return (
                                                    <div className="add-auth-chip-wrapper">
                                                        {selected.map((x, i) => (
                                                            <Chip
                                                                key={"chip" + i}
                                                                text={x.roomName}
                                                                status={"None"}
                                                                disableClicking={true}
                                                            />
                                                        ))}
                                                    </div>
                                                );
                                            }}
                                            MenuProps={{
                                                // ITEM_HEIGHT = 48;
                                                // ITEM_PADDING_TOP = 8;
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 48 * 4.5 + 8,
                                                    },
                                                },
                                            }}
                                        >
                                            {Array.isArray(roomMenu) &&
                                                roomMenu.map((room) => (
                                                    <MenuItem key={room.roomId} value={room}>
                                                        <Checkbox checked={handleCheck(room)} />
                                                        <ListItemText primary={room.roomName} />
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                    <div className="add-auth-buttons">
                                        <RectBtn onClick={confirmAddAuth}>Add Rooms</RectBtn>
                                        <p
                                            onClick={() => {
                                                cancelAddAuth();
                                            }}
                                        >
                                            Cancel
                                        </p>
                                    </div>
                                </div>
                            )}
                            {openAddAllAuth && (
                                <div className="add-auth-menu-content">
                                    <p> Add Rooms by Building</p>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel id="rooms-label">Buildings</InputLabel>
                                        <Select
                                            labelId="rooms-label"
                                            id="demo-multiple-checkbox"
                                            multiple
                                            value={authRoomsToAddByBuilding}
                                            onChange={(event) => {
                                                setAuthRoomsToAddByBuilding(event.target.value);
                                            }}
                                            input={<OutlinedInput label="Rooms To Add" />}
                                            renderValue={(selected) => {
                                                return (
                                                    <div className="add-auth-chip-wrapper">
                                                        {selected.map((x, i) => (
                                                            <Chip
                                                                key={"chip" + i}
                                                                text={x.buildingName}
                                                                status={"None"}
                                                                disableClicking={true}
                                                            />
                                                        ))}
                                                    </div>
                                                );
                                            }}
                                            MenuProps={{
                                                // ITEM_HEIGHT = 48;
                                                // ITEM_PADDING_TOP = 8;
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 48 * 4.5 + 8,
                                                    },
                                                },
                                            }}
                                        >
                                            {buildingMenu.map((building) => (
                                                <MenuItem key={building.buildingId} value={building}>
                                                    <Checkbox checked={handleBuildingCheck(building)} />
                                                    <ListItemText primary={building.buildingName} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <div className="add-auth-buttons">
                                        <RectBtn onClick={confirmAddAuth}>Add Rooms</RectBtn>
                                        <p onClick={cancelAddAuth}>Cancel</p>
                                    </div>
                                </div>
                            )}
                            {canDelete && (
                                <div className="auth-rooms-to-delete">
                                    <p className="header">Rooms To Delete</p>
                                    <div className="chip-row">
                                        {authRoomsToDelete &&
                                            Object.keys(authRoomsToDelete).map((key, i) => {
                                                let item = authRoomsToDelete[key];
                                                return (
                                                    <Chip
                                                        key={"chip" + i}
                                                        status={"None"}
                                                        text={item.roomName}
                                                        deletable={true}
                                                        deleteType="cancel"
                                                        onDelete={() => {
                                                            // remove room chip from authRoomsToDelete
                                                            let roomsToDeleteCopy = JSON.parse(
                                                                JSON.stringify(authRoomsToDelete)
                                                            );
                                                            delete roomsToDeleteCopy[key];
                                                            if (Object.keys(roomsToDeleteCopy).length === 0) {
                                                                roomsToDeleteCopy = null;
                                                            }
                                                            setAuthRoomsToDelete(roomsToDeleteCopy);
                                                            // unhide room chip from selectedUserRooms
                                                            let roomsCopy = JSON.parse(
                                                                JSON.stringify(selectedUserRooms)
                                                            );
                                                            roomsCopy[key].hidden = false;
                                                            setSelectedUserRooms(roomsCopy);
                                                        }}
                                                    />
                                                );
                                            })}
                                    </div>
                                    {authRoomsToDelete && (
                                        <div className="delete-btn-wrapper">
                                            <RectBtn warning={true} onClick={confirmDeleteAuth}>
                                                <p>Confirm Delete</p>
                                            </RectBtn>
                                            <p className="hint">Warning: This action cannot be restored.</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </PopUp>
    );
};

export default InspectAccountPopUp;
